import axios from 'axios';
import CreateUserNotify from 'notifications/emailTemplates/createUserNotify';
import ValidateFormNotify from 'notifications/emailTemplates/validateFormNotify';
import PreAuthorizeNotify from 'notifications/emailTemplates/preAuthorizeNotify';
import CreateProjectNotify from 'notifications/emailTemplates/createProjectNotify';
import RegistrationCompletedNotify from 'notifications/emailTemplates/registrationCompletedNotify';
import SubmitProposalNotify from 'notifications/emailTemplates/SubmitProposalNotify';
import ProposalDecisionNotify from 'notifications/emailTemplates/ProposalDecisionNotify';
import ContactNotify from 'notifications/emailTemplates/ContactNotify';

// const BASE_URL = '/api';
const BASE_URL = 'https://api.modernizacion.gob.sv/api';

class EmailServices {
  static createUserNotification(dst, user) {
    return createUserNotificationMail(dst, user);
  }

  static validationFormNotification(dst, user, docs) {
    return validationFormNotificationMail(dst, user, docs);
  }

  static preAuthorizeNotification(dst, user) {
    return preAuthorizeNotificationMail(dst, user);
  }

  static createProjectNotification(dst, user, project) {
    return createProjectNotificationMail(dst, user, project);
  }

  static submitProposalNotification(dst, user, userSend, project) {
    return submitProposalNotificationMail(dst, user, userSend, project);
  }

  static proposalDecisionNotification(dst, user, project, decision) {
    return proposalDecisionNotificationMail(dst, user, project, decision);
  }

  static registrationCompletedNotification(dst, user) {
    return registrationCompletedNotificationnMail(dst, user);
  }

  static contactNotification(dst, contactInfo) {
    return contactNotificationMail(dst, contactInfo);
  }
}

const createUserNotificationMail = async (dst, user) => {
  try {
    const emailData = CreateUserNotify.getEmailData(dst, user);
    const options = {
      method: 'post',
      url: `${BASE_URL}/email`,
      data: emailData
    };
    const response = await axios(options);
    return response.status === 200 ? response.data : false;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const validationFormNotificationMail = async (dst, user, docs) => {
  try {
    const emailData = ValidateFormNotify.getEmailData(dst, user, docs);
    const options = {
      method: 'post',
      url: `${BASE_URL}/email`,
      data: emailData
    };
    const response = await axios(options);
    return response.status === 200 ? response.data : false;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const preAuthorizeNotificationMail = async (dst, user) => {
  try {
    const emailData = PreAuthorizeNotify.getEmailData(dst, user);
    const options = {
      method: 'post',
      url: `${BASE_URL}/email`,
      data: emailData
    };
    const response = await axios(options);
    return response.status === 200 ? response.data : false;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const createProjectNotificationMail = async (dst, user, project) => {
  try {
    const emailData = CreateProjectNotify.getEmailData(dst, user, project);
    const options = {
      method: 'post',
      url: `${BASE_URL}/email`,
      data: emailData
    };
    const response = await axios(options);
    return response.status === 200 ? response.data : false;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const submitProposalNotificationMail = async (dst, user, userSend, project) => {
  try {
    const emailData = SubmitProposalNotify.getEmailData(dst, user, userSend, project);
    const options = {
      method: 'post',
      url: `${BASE_URL}/email`,
      data: emailData
    };
    const response = await axios(options);
    return response.status === 200 ? response.data : false;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const proposalDecisionNotificationMail = async (dst, user, project, decision) => {
  try {
    const emailData = ProposalDecisionNotify.getEmailData(dst, user, project, decision);
    const options = {
      method: 'post',
      url: `${BASE_URL}/email`,
      data: emailData
    };
    const response = await axios(options);
    return response.status === 200 ? response.data : false;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const registrationCompletedNotificationnMail = async (dst, user) => {
  try {
    const emailData = RegistrationCompletedNotify.getEmailData(dst, user);
    const options = {
      method: 'post',
      url: `${BASE_URL}/email`,
      data: emailData
    };
    const response = await axios(options);
    return response.status === 200 ? response.data : false;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const contactNotificationMail = async (dst, contactInfo) => {
  try {
    const emailData = ContactNotify.getEmailData(dst, contactInfo);
    const options = {
      method: 'post',
      url: `${BASE_URL}/email`,
      data: emailData
    };
    const response = await axios(options);
    return response.status === 200 ? response.data : false;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export default EmailServices;
